module.exports = {
    LOGIN_EVENT_ACCOUNT_LOGIN_SUCCESS : "LOGIN_EVENT_ACCOUNT_LOGIN_SUCCESS"
    ,LOGIN_EVENT_DEFSERVER_SUCCESS : "LOGIN_EVENT_DEFSERVER_SUCCESS"
    ,LOGIN_EVENT_CUR_SERVER_UPDATE : "LOGIN_EVENT_CUR_SERVER_UPDATE"
    ,DEFAULE_SERVER_SUCCESS : "LoginEvent.DEFAULE_SERVER_SUCCESS"
    ,LOGIN_EVENT_PLAYER_INFO : "LOGIN_EVENT_PLAYER_INFO"
};